<template>
    <ui5-dialog
        id="delivery-semifinished-product-dialog"
        ref="deliverySemifinishedProductAction"
    >
        <template v-if="firstSelectedProduct">
            <h3>
                Geef de stocklocatie(s) en het aantal colli op voor product
                {{
                    firstSelectedProduct.productId +
                    ' ' +
                    (firstSelectedProduct.producttypeName || '') +
                    ' - ' +
                    (firstSelectedProduct.reference || '')
                }}
            </h3>
            <div class="field">
                <ui5-label for="input-boxnr-deliver-1">
                    Stocklocatie 1
                </ui5-label>
                <combo-box-wrapper
                    :value="stockLocation1"
                    id="input-boxnr-deliver-1"
                    @input="stockLocation1 = $event"
                    v-if="stockLocationOptions"
                    :options="stockLocationOptions"
                />
            </div>
            <div class="field">
                <ui5-label for="input-boxnr-deliver-2">
                    Stocklocatie 2
                </ui5-label>
                <combo-box-wrapper
                    :value="stockLocation2"
                    id="input-boxnr-deliver-2"
                    @input="stockLocation2 = $event"
                    v-if="stockLocationOptions"
                    :options="stockLocationOptions"
                />
            </div>
            <div class="field">
                <ui5-label for="input-boxnr-deliver-3">
                    Stocklocatie 3
                </ui5-label>
                <combo-box-wrapper
                    :value="stockLocation3"
                    id="input-boxnr-deliver-3"
                    @input="stockLocation3 = $event"
                    v-if="stockLocationOptions"
                    :options="stockLocationOptions"
                />
            </div>
            <div class="field">
                <ui5-label for="input-colli-deliver">Colli</ui5-label>
                <ui5-input
                    type="Text"
                    id="input-colli-deliver"
                    :disabled="saving"
                    :value="colli"
                    @input="colli = $event.target.value"
                />
            </div>
            <div class="actions">
                <ui5-button
                    @click="processSemiFinishedDelivered"
                    id="process-semifinished-delivered"
                    :disabled="saving"
                >
                    <spinner v-if="saving" />
                    Verwerken
                </ui5-button>
                <ui5-button
                    id="cancel-semifinished-delivered"
                    :disabled="saving"
                    @click="closePopup"
                >
                    Annuleren
                </ui5-button>
            </div>
        </template>
    </ui5-dialog>
</template>

<script>
import productApi from '../../api/product';
import Spinner from '../loader/Spinner';
import ComboBoxWrapper from '../ComboBoxWrapper';
import { showErrorMessage } from '../../dialogs';

export default {
    components: { Spinner, ComboBoxWrapper },
    props: [
        'firstSelectedProduct',
        'updateBoxNrAndColliForProduct',
        'printSemifinishedProductLabel',
        'stockLocationOptions',
    ],
    data() {
        return {
            saving: false,
            boxnr: '',
            colli: '',
            stockLocation1: null,
            stockLocation2: null,
            stockLocation3: null,
        };
    },
    watch: {
        firstSelectedProduct: {
            deep: true,
            handler() {
                if (this.firstSelectedProduct) {
                    this.colli = this.firstSelectedProduct.colli;
                    this.stockLocation1 =
                        this.firstSelectedProduct.stockLocations[0];
                    this.stockLocation2 =
                        this.firstSelectedProduct.stockLocations[1];
                    this.stockLocation3 =
                        this.firstSelectedProduct.stockLocations[2];
                } else {
                    this.colli = '';
                    this.stockLocation1 = null;
                    this.stockLocation2 = null;
                    this.stockLocation3 = null;
                }
            },
        },
    },
    methods: {
        showPopup() {
            if (!this.firstSelectedProduct) {
                return showErrorMessage(
                    'Selecteer eerst de producten die u wenst te verwerken.'
                );
            }
            const product = this.firstSelectedProduct;
            if (!product.stockLocations || !product.stockLocations[0]) {
                this.$refs.deliverySemifinishedProductAction.show();
            } else {
                this.processDelivered(product);
            }
        },
        processSemiFinishedDelivered() {
            const product = this.firstSelectedProduct;
            const colli = this.colli;
            const stockLocation1 = this.stockLocation1;
            const stockLocation2 = this.stockLocation2;
            const stockLocation3 = this.stockLocation3;
            if (stockLocation1 && colli) {
                product.boxnr = '';
                product.colli = colli;
                product.stockLocations = [
                    this.stockLocation1,
                    this.stockLocation2,
                    this.stockLocation3,
                ];
                this.saving = true;
                this.updateBoxNrAndColliForProduct(product);
                this.processDelivered(product);
            } else {
                showErrorMessage(
                    'Boxnr 1 moet ingevuld zijn en colli moet groter zijn dan 0.'
                );
            }
        },
        processDelivered(product) {
            this.saving = true;
            productApi
                .processDelivered(
                    product.productId,
                    '',
                    product.colli,
                    product.stockLocations
                )
                .then(() => {
                    this.printSemifinishedProductLabel(
                        product.productId,
                        false,
                        () => {
                            product.selected = false;
                            this.closePopup();
                            if (this.firstSelectedProduct) {
                                this.showPopup();
                            }
                        }
                    );
                })
                .finally(() => {
                    this.saving = false;
                });
        },
        closePopup() {
            this.$refs.deliverySemifinishedProductAction.close();
        },
    },
};
</script>
